import {makeActionCreator} from '../utility'


export const SIGNIN_ACTION = 'SIGNIN_ACTION'
export const signinAction = makeActionCreator(SIGNIN_ACTION, 'data')

export const SUBMIT_REGISTRATION = 'SUBMIT_REGISTRATION'
export const submitRegistration = makeActionCreator(SUBMIT_REGISTRATION,'data')

export const SUBMIT_REGISTRATION_SUCCESSFUL = 'SUBMIT_REGISTRATION_SUCCESSFUL'
export const submitregistrationSuccessful = makeActionCreator(SUBMIT_REGISTRATION_SUCCESSFUL, 'data')

export const CURRENT_USER = 'CURRENT_USER'
export const currentUser = makeActionCreator(CURRENT_USER, 'data')

export const SIGNIN_STATUS= 'SIGNIN_STATUS'
export const signinStatus = makeActionCreator(SIGNIN_STATUS, 'data')

export const REGISTRATION_STATUS= 'REGISTRATION_STATUS'
export const registrationStatus = makeActionCreator(REGISTRATION_STATUS, 'data')


export const RESET_PASSWORD = 'RESET_PASSWORD'
export const resetPassword = makeActionCreator (RESET_PASSWORD, 'data')

export const RESET_PASSWORD_SUCCESSFUL = 'RESET_PASSWORD_SUCCESSFUL'
export const resetPasswordSuccessful = makeActionCreator (RESET_PASSWORD_SUCCESSFUL, 'data')


export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const changePassword = makeActionCreator (CHANGE_PASSWORD, 'data')

export const CHANGE_PASSWORD_SUCCESSFUL = 'CHANGE_PASSWORD_SUCCESSFUL'
export const changePasswordSuccessful = makeActionCreator (CHANGE_PASSWORD_SUCCESSFUL, 'data')


export const ACTIVATE_EMAIL = 'ACTIVATE_EMAIL'
export const activateEmail = makeActionCreator(ACTIVATE_EMAIL, 'data')

export const HAS_ACTIVATE_EMAIL = 'HAS_ACTIVATE_EMAIL'
export const hasActivatedEmail = makeActionCreator(HAS_ACTIVATE_EMAIL, 'data')

export const VALIDATE_TOKEN = 'VALIDATE_TOKEN'
export const validateToken = makeActionCreator(VALIDATE_TOKEN, 'data')


export const HAS_VALIDATED_TOKEN = 'HAS_VALIDATED_TOKEN'
export const hasValidatedToken = makeActionCreator(HAS_VALIDATED_TOKEN, 'data')


export const ACTIVATE_MEMBER_ACCOUNT = 'ACTIVATE_MEMBER_ACCOUNT'
export const activateMemberAccount = makeActionCreator(ACTIVATE_MEMBER_ACCOUNT, 'data')

export const HAS_ACTIVATED_MEMBER_ACCOUNT = 'HAS_ACTIVATED_MEMBER_ACCOUNT'
export const hasActivatedMemberAccount = makeActionCreator(HAS_ACTIVATED_MEMBER_ACCOUNT, 'data')
